import "./FormInput.scss";

const FormInput = ({ handleChange, label, ...otherProps }) => (
  <div className="group">
    <input className="form-input" onChange={handleChange} {...otherProps} />
    {label ? (
      <label
        htmlFor=""
        className={`${otherProps.value.lenght ? "shrink" : ""}
        form-input-label`}
      >
        {label}
      </label>
    ) : null}
  </div>
);

export default FormInput;
